// extracted by mini-css-extract-plugin
export default {"bundles-list":"bundles-list-9a72","bundle-container":"bundle-container-0d92"};